export default __webpack_public_path__ + "static/media/medicalenggrepeaterbannerDesk.6d99c277.png";